import React from 'react'

const ResponseObservation = ({ responseObsData, handleResponseObservation}) => {
  return (
    <div className="observation-content">
        <div className="d-flex align-items-center gap-18">
        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Anxious"
                id="Anxious"
                checked={responseObsData?.Anxious === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Anxious</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Cooperative"
                id="Cooperative"
                checked={responseObsData?.Cooperative === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Cooperative</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Confused"
                id="Confused"
                checked={responseObsData?.Confused === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Confused</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Distracted"
                id="Distracted"
                checked={responseObsData?.Distracted === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Distracted</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Engaged"
                id="Engaged"
                checked={responseObsData?.Engaged === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Engaged</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Emotional"
                id="Emotional"
                checked={responseObsData?.Emotional === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Emotional</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Resistant"
                id="Resistant"
                checked={responseObsData?.Resistant === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Resistant</p>
        </label>

        <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
            <input
                type="checkbox"
                className="form-check-input m-0 p-0"
                name="Withdraw"
                id="Withdraw"
                checked={responseObsData?.Withdraw === "true"}
                onChange={handleResponseObservation}
            />
            </div>
            <p className="text fs-13">Withdraw</p>
        </label>

        </div>

    </div>
  )
}

export default ResponseObservation